<div class="filter_list grid">
    <label class="inp_group">
        <div class="lbl">Название</div>
        <input type="text" [(ngModel)]="productFilter.name" name="productName" class="inp" placeholder="Название товара">
    </label>
    <label class="inp_group">
        <div class="lbl">Требует доставку</div>
        <select [(ngModel)]="productFilter.requireShipping" name="requireShipping" class="inp">
            <option [ngValue]="undefined">Все</option>
            <option value="true" >Да</option>
            <option value="false">Нет</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">Включён товар</div>
        <select [(ngModel)]="productFilter.isEnabled" name="isEnabled" class="inp">
            <option [ngValue]="undefined">Все</option>
            <option value="true">Да</option>
            <option value="false">Нет</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">Сумма ($)</div>
        <mat-slider class="slider_input" [min]="0" [max]="2050" [step]="50" discrete>
            <input [(ngModel)]="productFilter.priceFrom" matSliderStartThumb>
            <input [(ngModel)]="productFilter.priceTo" matSliderEndThumb>
        </mat-slider>
    </label>
</div>